import { useDescope } from '@descope/react-sdk';
import { useQuery } from 'react-query';
import { useCanAccessAdminPortal } from 'state/access';
import { useProjectCtx } from 'state/project/ProjectCtx';
import { ListWidgetsResponse } from 'types/widgets';
import { adminPortalGet } from './api';
import { API_ROUTES, qk } from './apiRoutes';

const getProjectWidgets = async (
	projectId: string,
	refreshToken?: string,
	cookieName?: string
): Promise<ListWidgetsResponse> => {
	const res = await adminPortalGet<ListWidgetsResponse>(
		API_ROUTES.projectWidgets(),
		projectId,
		refreshToken,
		cookieName
	);
	return res.data;
};

export const useProjectWidgets = () => {
	const { projectId, cookieName } = useProjectCtx();
	const [canAccess] = useCanAccessAdminPortal();
	const { getRefreshToken } = useDescope();

	return useQuery({
		queryKey: qk.projectWidgets(),
		queryFn: () => getProjectWidgets(projectId!, getRefreshToken(), cookieName),
		staleTime: Infinity,
		enabled: !!projectId && canAccess
	});
};
